"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUsersSearchQueries = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function createUsersSearchQueries(_a) {
    var data = _a.data;
    var variables = {
        data: data,
    };
    return {
        mutation: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      mutation($data: UsersSearchQueriesCreateInput!) {\n        createUsersSearchQueries(data: $data) {\n          id\n        }\n      }\n    "], ["\n      mutation($data: UsersSearchQueriesCreateInput!) {\n        createUsersSearchQueries(data: $data) {\n          id\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.createUsersSearchQueries = createUsersSearchQueries;
var templateObject_1;
